import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApplicationService } from '../../services/application.service';
import { TranslationService } from '../../services/translation.service';
import type { JobSalaryTranslations } from '../../i18n/job-salary';
import en from '../../i18n/en/job-salary';

@Component({
  selector: 'app-job-salary',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './job-salary.component.html',
  styleUrls: ['./job-salary.component.css'],
})
export class JobSalaryComponent {
  @Input() applicationId!: number;
  @Input() jobTitle!: string;
  @Input() companyName!: string;
  @Input() salary_min_value: number | null = null;
  @Input() salary_max_value: number | null = null;
  @Input() salary_target_value: number | null = null;
  @Input() salary_company_message: string | null = '';
  @Output() salaryUpdated = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  salaryForm: FormGroup;
  isSubmitting = false;

  translations: JobSalaryTranslations = en as JobSalaryTranslations;

  get t(): JobSalaryTranslations {
    return this.translations;
  }

  constructor(
    private fb: FormBuilder,
    private applicationService: ApplicationService,
    private translationService: TranslationService
  ) {
    this.salaryForm = this.fb.group({
      salary_min_value: [null, [Validators.min(0)]],
      salary_max_value: [null, [Validators.min(0)]],
      salary_target_value: [null, [Validators.min(0)]],
      salary_company_message: [''],
    });

    const current = this.translationService.getJobSalaryTranslations();
    if (current) {
      this.translations = current;
    }
    this.translationService.onChange(() => {
      const next = this.translationService.getJobSalaryTranslations();
      if (next) {
        this.translations = next;
      }
    });
  }

  ngOnChanges() {
    this.salaryForm.patchValue({
      salary_min_value: this.salary_min_value,
      salary_max_value: this.salary_max_value,
      salary_target_value: this.salary_target_value,
      salary_company_message: this.salary_company_message,
    });
  }

  onSubmit() {
    if (this.salaryForm.valid && this.applicationId) {
      this.isSubmitting = true;
      this.applicationService
        .updateApplicationSalary(this.applicationId, this.salaryForm.value)
        .subscribe({
          next: (res) => {
            this.isSubmitting = false;
            this.salaryUpdated.emit({
              ...this.salaryForm.value,
              ...(res && typeof res === 'object' ? res : {}),
            });
          },
          error: () => {
            this.isSubmitting = false;
          },
        });
    } else {
      this.salaryForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.cancel.emit();
  }
}
